/* import __COLOCATED_TEMPLATE__ from './reset-pin.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();